<template>
  <div style="background-color: #F4F7FE; min-height: 100vh;" class="pa-6">
    <v-row class="mb-6 px-4" align="center">
      <v-col cols="12" md="6">
        <h2 class="text-h4 font-weight-black" style="color: #1B2559;">Gestión de Miembros</h2>
        <div class="d-flex align-center mt-1">
          <v-icon small color="#4318FF" class="mr-2">mdi-account-multiple-check</v-icon>
          <span class="text-subtitle-2 font-weight-bold" style="color: #A3AED0;">
            Administra la base de miembros de LIVE FIT
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-md-end align-center">
         <v-text-field
          v-model="busqueda"
          append-icon="mdi-magnify"
          label="Buscar miembro..."
          solo-inverted
          flat
          hide-details
          class="rounded-lg mr-4"
          style="max-width: 300px"
        ></v-text-field>
        <v-btn color="#4318FF" dark class="rounded-lg elevation-1 text-none font-weight-bold" to="/nuevo-miembro">
          <v-icon left>mdi-plus</v-icon> Nuevo Miembro
        </v-btn>
      </v-col>
    </v-row>

    <v-card class="rounded-xl elevation-1 border-0 pa-4">
      <v-data-table
        :loading="cargando"
        :headers="encabezadoTabla"
        :items="miembros"
        :search="busqueda"
        item-key="matricula"
        show-expand
        class="elevation-0"
        :footer-props="{ itemsPerPageText: 'Filas por página' }"
      >
        <template v-slot:[`item.imagen`]="{ item }">
          <v-avatar size="45" class="elevation-1 border">
            <img :src="urlImagen(item.imagen)" alt="Foto" />
          </v-avatar>
        </template>

        <template v-slot:[`item.matricula`]="{ item }">
          <code class="font-weight-bold grey--text text--darken-3 px-2 py-1 rounded">{{ item.matricula }}</code>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <v-chip
            small
            class="font-weight-black"
            :color="estadoColor(item.estado)"
            text-color="white"
          >
            <v-icon left x-small>mdi-circle</v-icon>
            {{ mostrarEstado(item.estado) }}
          </v-chip>
        </template>

        <template v-slot:[`item.fechaFin`]="{ item }">
          <span class="caption font-weight-bold" :class="item.estado === 'VENCIDO' ? 'error--text' : 'indigo--text'">
            {{ formatearFecha(item.fechaFin) || '---' }}
          </span>
        </template>

        <template v-slot:[`item.fechaInicio`]="{ item }">
          <span class="caption font-weight-medium indigo--text">
            {{ formatearFecha(item.fechaInicio) || '---' }}
          </span>
        </template>

        <template v-slot:[`item.opciones`]="{ item }">
          <div class="d-flex align-center">
            <v-btn icon class="action-edit" @click="editar(item.id)">
              <v-icon small>mdi-pencil-outline</v-icon>
            </v-btn>
            <v-btn icon class="action-primary" @click="generarCredencial(item)">
              <v-icon small>mdi-card-account-details-outline</v-icon>
            </v-btn>
             <v-btn v-if="!item.estado || item.estado === 'VENCIDO'" icon class="v-btn--icon" @click="realizarPago(item.matricula)">
              <v-icon small>mdi-wallet-membership</v-icon>
            </v-btn>
            <v-btn icon class="action-danger" @click="eliminar(item)">
              <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-0">
            <v-card flat color="#F4F7FE" class="pa-6 rounded-0">
              <v-row>
                <v-col cols="12" md="4">
                  <h4 class="text-overline grey--text">Información Personal</h4>
                  <p class="mb-1"><v-icon small class="mr-2">mdi-map-marker</v-icon> <b>Dirección:</b> {{ item.direccion }}</p>
                  <p class="mb-1"><v-icon small class="mr-2">mdi-calendar</v-icon> <b>Edad:</b> {{ item.edad }} años</p>
                  <p class="mb-1"><v-icon small class="mr-2">mdi-account-clock</v-icon> <b>Registro:</b> {{ item.fechaRegistro }}</p>
                </v-col>
                <v-col cols="12" md="4">
                  <h4 class="text-overline grey--text">Contacto de Emergencia</h4>
                  <p class="mb-1"><v-icon small class="mr-2">mdi-account-alert</v-icon> <b>Nombre:</b> {{ item.nombreContacto }}</p>
                  <p class="mb-1"><v-icon small class="mr-2">mdi-phone</v-icon> <b>Teléfono:</b> {{ item.telefonoContacto }}</p>
                </v-col>
                <v-col cols="12" md="4">
                  <h4 class="text-overline grey--text">Salud e Institución</h4>
                  <p class="mb-1"><v-icon small class="mr-2">mdi-heart-pulse</v-icon> <b>Enfermedades:</b> {{ item.enfermedad || 'Ninguna' }}</p>
                  <p class="mb-1"><v-icon small class="mr-2">mdi-hospital-building</v-icon> <b>Seguro:</b> {{ item.institucion || 'No especifica' }}</p>
                </v-col>
              </v-row>
            </v-card>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="mostrarRealizarPago" persistent max-width="600">
      <realizar-pago :matricula="matriculaSeleccionada" @cerrar="cerrarDialogoPago" @pagado="onPagado" />
    </v-dialog>

    <v-dialog v-model="mostrarDialogoEliminar" max-width="500px">
      <dialogo-eliminar :nombre="itemSeleccionado" @cancelar="cerrarDialogoEliminar" @eliminar="confirmarEliminar" />
    </v-dialog>

    <credencial-miembro :matricula="matriculaSeleccionada" :miembro="miembro" @impreso="onImpreso" v-if="mostrarCredencial"/> 

    <v-overlay :value="cargando" color="#1B2559" opacity="0.8">
      <v-progress-circular indeterminate size="64" color="#4318FF" width="6"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top rounded="pill">
      {{ mensaje.texto }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="mostrarMensaje = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
import Utiles from "../../Servicios/Utiles";
import RealizarPago from "./RealizarPago.vue";
import DialogoEliminar from "../Dialogos/DialogoEliminar.vue";
import CredencialMiembro from "./CredencialMiembro.vue";

export default {
  name: "MiembrosPremium",
  components: { RealizarPago, DialogoEliminar, CredencialMiembro },

  data: () => ({
    busqueda: "",
    cargando: false,
    mostrarMensaje: false,
    mensaje: { color: "", texto: "" },
    miembros: [],
    matriculaSeleccionada: "",
    mostrarRealizarPago: false,
    itemSeleccionado: null,
    miembro: null,
    mostrarDialogoEliminar: false,
    mostrarCredencial: false,
    encabezadoTabla: [
      { text: "Imagen", value: "imagen", sortable: false, width: "70px" },
      { text: "Matrícula", value: "matricula", sortable: true },
      { text: "Nombre Completo", value: "nombre", sortable: true },
      { text: "Teléfono", value: "telefono", sortable: false },
      { text: "Estado", value: "estado", sortable: true },
      { text: "Inicio", value: "fechaInicio", sortable: true },
      { text: "Vencimiento", value: "fechaFin", sortable: true },
      { text: "Plan", value: "membresia", sortable: true },
      { text: "Opciones", value: "opciones", sortable: false, align: "center" },
    ],
  }),

  mounted() {
    this.obtenerMiembros();
  },

  methods: {
    async obtenerMiembros() {
      this.cargando = true;
      try {
        const res = await HttpService.obtenerConDatos({ metodo: "get" }, "miembros.php");
        this.miembros = Array.isArray(res) ? res : (res.miembros || []);
      } catch (e) {
        console.error("Error obteniendo miembros:", e);
        this.miembros = [];
      } finally {
        this.cargando = false;
      }
    },

    generarCredencial(miembro) {
      this.matriculaSeleccionada = miembro.matricula;
      this.miembro = miembro;
      this.mostrarCredencial = true;
    },
    onImpreso(resultado) { this.mostrarCredencial = resultado; },
    eliminar(miembro) {
      this.itemSeleccionado = miembro.nombre;
      this.miembro = miembro;
      this.mostrarDialogoEliminar = true;
    },
    cerrarDialogoEliminar() { this.mostrarDialogoEliminar = false; },
    confirmarEliminar() {
      this.cargando = true;
      HttpService.eliminar("miembros.php", { metodo: "eliminar", id: this.miembro.id }).then((eliminado) => {
        if (eliminado) {
          this.mostrarDialogoEliminar = true;
          this.mostrarDialogoEliminar = false;
          this.mensaje.texto = "Miembro eliminado";
          this.mensaje.color = "error";
          this.mostrarMensaje = true;
          this.obtenerMiembros();
        }
      });
    },
    editar(idMiembro) {
      this.$router.push({ name: "EditarMiembro", params: { id: idMiembro } });
    },
    urlImagen(imagen) {
      return Utiles.generarURL(imagen, 'miembros');
    },
    cerrarDialogoPago(resultado) { this.mostrarRealizarPago = resultado; },
    realizarPago(matricula) {
      this.matriculaSeleccionada = matricula;
      this.mostrarRealizarPago = true;
    },
    formatearFecha(fecha) {
      if (!fecha) return '---';
      const f = fecha.split(" ")[0];
      const [y, m, d] = f.split("-");
      return `${d}.${m}.${y.slice(2)}`;
    },
    estadoColor(val) {
      // ACTIVO -> verde; cualquier otro (VENCIDO, null, '') -> gris/amarillo suave
      if (val === "ACTIVO") return "#05CD99";
      return "#FFB547";
    },
    mostrarEstado(val) {
      // Mostrar 'Activo' solo si realmente está ACTIVO.
      // Si está VENCIDO o NULL/'' mostramos 'Sin membresía' (según requeriste)
      if (val === "ACTIVO") return "Activo";
      return "Sin membresía";
    },
    onPagado(resultado) {
      // cierra el diálogo de pago, muestra mensaje y refresca la lista
      if (resultado) {
        this.mostrarRealizarPago = false;
        this.mensaje.texto = "Pago realizado con éxito";
        this.mensaje.color = "success";
        this.mostrarMensaje = true;
        // refrescar listado para reflejar nuevo estado del miembro
        this.obtenerMiembros();
      }
    },
  },
};
</script>

<style scoped>
/* Transición suave para la expansión y botones */
.v-data-table >>> .v-data-table__expanded__content {
  box-shadow: inset 0 0 10px rgba(0,0,0,0.05) !important;
}
.v-btn--icon {
  margin: 0 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/Miembros/Miembros.vue